import {
  START_LOADING,
  END_LOADING,
  CREATE_USER,
  UPDATE_USER,
  DELETE_USER,
  FETCH_USER,
  FETCH_USERS,
} from "../actions/constants";

const users = (state = { isLoading: false, users: [] }, action) => {
  switch (action.type) {
    case START_LOADING:
      return { ...state, isLoading: true };
    case END_LOADING:
      return { ...state, isLoading: false };
    case FETCH_USERS:
      return {
        ...state,
        users: action.payload.users,
        numberOfPages: action.payload.numberOfPages,
      };
    case FETCH_USER:
      return { ...state, user: action.payload };
    case CREATE_USER:
      return { ...state, users: [...state.users, action.payload] };
    case UPDATE_USER:
      return {
        ...state,
        users: state.users.map((user) =>
          user._id === action.payload._id ? action.payload : user
        ),
      };
    case DELETE_USER:
      return {
        ...state,
        users: state.users.filter((user) => user._id !== action.payload),
      };
    default:
      return state;
  }
};

export default users;
